import memoize from 'lodash/memoize';

/** @deprecated TODO remove in DEV-25601 */
export const findOption =
  (valueKey, options = []) =>
  (value) => {
    let result;

    options.forEach((option) => {
      if (option.options) {
        result = findOption(valueKey, option.options)(value);
        // @ts-expect-error
      } else if (value && typeof item === 'object') {
        if (value[valueKey] === option[valueKey]) {
          result = option;
        }
      } else if (value === option[valueKey]) {
        result = option;
      }
    });

    return result || value;
  };

/** @deprecated TODO remove in DEV-25601 */
export const tryToStringify = (value) => {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return value;
  }
};

/** @deprecated TODO remove in DEV-25601 */
export const valueToOption = (value, options, valueKey = 'id') => {
  if (!options) {
    return value;
  } else if (value && typeof value === 'object' && Object.keys(value).length > 1) {
    return value;
  }
  const optionFromValue = options.find((option) => [option, option[valueKey]].includes(value[valueKey]));
  return optionFromValue || value;
};

/** @deprecated TODO remove in DEV-25601 */
export const getReactSelectStyles = memoize((multi, isFixedOption, styles = {}) => {
  const multiStyles = multi
    ? {
        multiValue: (base, state) => {
          const isFixed = typeof isFixedOption === 'function' && isFixedOption(state.data);
          return isFixed ? { ...base, backgroundColor: 'gray' } : base;
        },
        multiValueLabel: (base, state) => {
          const isFixed = typeof isFixedOption === 'function' && isFixedOption(state.data);
          return isFixed ? { ...base, fontWeight: 'bold', color: 'gray' } : base;
        },
        multiValueRemove: (base, state) => {
          const isFixed = typeof isFixedOption === 'function' && isFixedOption(state.data);
          return isFixed ? { ...base, display: 'none' } : base;
        },
      }
    : {};

  return {
    ...styles,
    ...multiStyles,
  };
});
